import { Component, Input, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { FileManagerService } from '../../../../file-manager/services/fileManager.services';
import { ToastrService } from 'ngx-toastr';

const FileSaver = require('file-saver');

interface FileManagerItem {
  fileManagerItemID: number;
  createdOn?: Date;
  isActive: boolean;
  azureblobPath?: string;
  name: string;
  projectID?: number;
}

@Component({
  selector: 'file-doc-detail',
  templateUrl: './file-detail.component.html',
  styleUrls: ['./file-detail.component.scss']
})
export class FileDetailComponent implements OnInit {
  @Input() fileItems: FileManagerItem[] = [];

  constructor(
    private loaderService: LoaderService,
    private fileManagerService: FileManagerService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
  }

  // Download file using API
  downloadFile(item: FileManagerItem) {
    if (!item.azureblobPath) {
      this.toastr.error('File URL not found.');
      return;
    }

    const selectedFileName = item.azureblobPath.split('/').pop();
    this.loaderService.show();

    this.fileManagerService.getAttachment(selectedFileName!, item.azureblobPath).subscribe({
      next: (response: any) => {
        this.loaderService.hide();

        if (response && response.data) {
          const data = `data:${response.data.contentType};base64,${response.data.base64URL}`;
          FileSaver.saveAs(data, selectedFileName);
        } else {
          this.toastr.error('File download failed.', '', { timeOut: 3000 });
        }
      },
      error: (err) => {
        this.loaderService.hide();       
        this.toastr.error('File download failed.', '', { timeOut: 3000 });
      }
    });
  }

  // renameFile(item: FileManagerItem) {
  // }

  // deleteFile(item: FileManagerItem) {
  // }

  // viewDetails(item: FileManagerItem) {
  // }

  // shareFile(item: FileManagerItem) {
  // }
}
